import { ChainId } from "../config/chain";

type TScanLinkParams = {
  path?: "account" | "tx" | "token";
  value: string;
  linkSuffix?: string;
  chainId?: ChainId;
};

export const getSolanaExplorerUrl = ({
  path = "account",
  value,
  linkSuffix,
  chainId = ChainId.SOLANA_MAINNET,
}: TScanLinkParams) => {
  return `https://solscan.io/${path}/${value}${linkSuffix}${
    chainId === ChainId.SOLANA_DEVNET ? "?cluster=devnet" : ""
  }`;
};
